export const generateSlug = (text) => {
  if (!text) return 'details';
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
};

export const generateArticleSchema = (title, url, datePublished, department) => {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    },
    "headline": title || "Sarkari Result Update",
    "datePublished": datePublished ? new Date(datePublished).toISOString() : new Date().toISOString(),
    "dateModified": datePublished ? new Date(datePublished).toISOString() : new Date().toISOString(),
    "author": {
      "@type": "Organization",
      "name": "Sarkari Result Cloud"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Sarkari Result Cloud",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.sarkariresult.cloud/logo.png"
      }
    },
    "articleSection": department || "Government Jobs"
  };
};
